import React from "react";
import { Box, Text, Icon, CloseButton } from "@chakra-ui/react";
import { InformationCircleIcon, CheckCircleIcon, ExclamationTriangleIcon, ExclamationCircleIcon, XMarkIcon, } from "@heroicons/react/24/outline";
import Balancer from "@hightouchio/react-wrap-balancer";
import { Button } from "./button";
import { Link } from "./link";
export function Alert({ isDismissible = false, variant, title, message, actionText, actionUrl, onAction, onDismiss, ...props }) {
    let color = "teal";
    let icon = InformationCircleIcon;
    if (variant === "success") {
        color = "success";
        icon = CheckCircleIcon;
    }
    if (variant === "warning") {
        color = "warning";
        icon = ExclamationTriangleIcon;
    }
    if (variant === "error") {
        color = "danger";
        icon = ExclamationCircleIcon;
    }
    return (React.createElement(Box, { display: "flex", gap: 3, bg: `${color}.background`, borderWidth: 1, borderColor: `${color}.border`, borderRadius: "md", p: 4, ...props },
        React.createElement(Box, { flex: "1", minWidth: 0, display: "flex", alignItems: "start", gap: 3 },
            React.createElement(Icon, { flex: "none", as: icon, color: `${color}.base`, boxSize: 6 }),
            React.createElement(Box, { flex: "1", minWidth: 0 },
                React.createElement(Text, { fontWeight: "semibold" },
                    React.createElement(Balancer, { ratio: 0.65 }, title)),
                React.createElement(Text, { mt: 1 },
                    React.createElement(Balancer, { ratio: 0.65 }, message)),
                actionText && (React.createElement(Box, { mt: 3 }, actionUrl ? (React.createElement(Link, { href: actionUrl }, actionText)) : (React.createElement(Button, { onClick: onAction }, actionText)))))),
        isDismissible && (React.createElement(CloseButton, { flex: "none", "aria-label": "Dismiss", sx: {
                "--close-button-size": "20px",
            }, _focus: {
                // Override app styles
                outline: "none !important",
            }, onClick: onDismiss },
            React.createElement(Icon, { as: XMarkIcon, boxSize: 4, color: "gray.800" })))));
}
